/**
 * @fileoverview Flight vs Crew Compare API Service
 * @description API calls for running a source→target flight/crew comparison.
 */

import { apiClient } from '@/services';

const BASE = '/v1/flight-crew-compare';

export const flightCrewCompareApi = {
  health: () => apiClient.get(`${BASE}/health`),

  /**
   * Run a comparison between a source (flights) and target (crew) connection.
   * @param {Object} payload
   * @param {number} payload.source_connection_id - Saved connection id (flights)
   * @param {number} payload.target_connection_id - Saved connection id (crew)
   * @param {string} [payload.source_queue_target] - 'active' | 'deadletter' | 'both'
   * @param {string} [payload.target_queue_target] - 'active' | 'deadletter' | 'both'
   * @param {number} [payload.flight_limit] - Max distinct flights to compare
   * @param {number} [payload.source_scan_limit] - Max source messages to scan
   * @param {number} [payload.target_scan_limit] - Max target messages to scan
   * @param {Object} [payload.field_config] - JSON path overrides
   * @returns {Promise<{summary, flights, error}>}
   */
  run: (payload) => apiClient.post(`${BASE}/run`, payload),
};
